/* unplugin-vue-components disabled */import { render } from "./HeaderTerms.vue?vue&type=template&id=1253bed9"
import script from "./HeaderTerms.vue?vue&type=script&lang=js"
export * from "./HeaderTerms.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__